import { LOCALES } from './locales';

export function getInitialLocale() {
  return localStorage.getItem('locale') || LOCALES.ENGLISH_UK;
}
